import React from "react";
import { Tooltip, Tag } from "antd";
import { ColumnsType } from "antd/lib/table";
import { In, UserOutlined } from "assets/icons";
import ViewDocument from "components/documentInfo/ViewDocument";
import dayjs from "dayjs";
import theme from "styles/theme";
import { IColumn } from "typings/global";
import { truncateText, unauthorizedRolesInLobbyTableActions } from "utils/functions";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "../styled/index.styled";

const ColumnsTableCheckin = ({ handlesClickCheckin, isConcierge, allowRequestVehicleInboundAction, allowRequestDockEntryAction, userData }) => {
  const CARRIER = useTranslation({ id: "carrier" });
  const PLATE = useTranslation({ id: "plate" });
  const TRAILERS_PLATE = useTranslation({ id: "trailers_plate" });
  const PROCESSES = useTranslation({ id: "processes" });
  const DOCUMENTS = useTranslation({ id: "documents" });
  const CHANNEL = useTranslation({ id: "channel" });
  const ARRIVAL = useTranslation({ id: "arrival" });
  const ACTIONS = useTranslation({ id: "actions" });
  const CALL_DRIVER = useTranslation({ id: "call_driver" });
  const CHECK_IN = useTranslation({ id: "check_in" });
  const STATUS = useTranslation({ id: "status" });
  const RELEASED = useTranslation({ id: "released" });

  const collums: Array<IColumn> = [
    {
      dataIndex: "carrier",
      width: "28%",
      title: CARRIER,
      key: "carrier",
      render: (carrier: string) => truncateText(carrier),
    },
    {
      dataIndex: "vehiclePlate",
      width: "10%",
      title: PLATE,
      key: "vehiclePlate",
      render: (vehiclePlate: ColumnsType<string>) => `${vehiclePlate}`,
    },
    {
      dataIndex: "trailersplate",
      width: "10%",
      title: TRAILERS_PLATE,
      key: "trailersplate",
      render: (trailersplate: ColumnsType<string>) => (trailersplate === undefined || trailersplate?.length === 0 ? "--" : <span>{trailersplate.join("\n")}</span>),
    },
    {
      dataIndex: "process",
      width: "13%",
      title: PROCESSES,
      key: "process",
      render: (process: ColumnsType<string>) => (process === null || process === undefined ? "--" : `${process}`),
    },
    {
      title: STATUS,
      dataIndex: "isReleased",
      key: "isReleased",
      width: "5%",
      render: (_, record) => (
        <span>
          <Tag
            key={record.radiusInEventTime}
            color={record.isReleased ? theme["@color-positive-200"] : theme.colors.grayTag}
            style={{ ...S.TagStatus, minWidth: record.isReleased ? "90px" : "10px" }}
          >
            {record.isReleased ? RELEASED : null}
          </Tag>
        </span>
      ),
    },
    {
      key: "documents",
      dataIndex: "documents",
      title: DOCUMENTS,
      width: "6%",
      render: (documents: ColumnsType<string>, record) => <ViewDocument record={record} documents={documents} handlesClick={handlesClickCheckin} />,
    },
    {
      key: "saleChannelDescription",
      dataIndex: "saleChannelDescription",
      title: CHANNEL,
      width: "13%",
      render: (saleChannelDescription: ColumnsType<string>) => (saleChannelDescription === undefined || saleChannelDescription === null ? "--" : `${saleChannelDescription}`),
    },
    {
      title: ARRIVAL,
      dataIndex: "radiusInEventTime",
      width: "9%",
      key: "radiusInEventTime",
      render: (radiusInEventTime: string) => (radiusInEventTime === "" || radiusInEventTime === null ? "--" : `${dayjs.utc(radiusInEventTime).local().format("DD/MM/YYYY HH:mm")}`),
    },
    {
      title: ACTIONS,
      dataIndex: "action",
      width: "6%",
      key: "actions",
      render: (_, record) =>
        record.action === true && (
          <S.ActionContainerCheckin allowRequestVehicleInboundAction={allowRequestVehicleInboundAction} allowRequestDockEntryAction={allowRequestDockEntryAction}>
            {(allowRequestVehicleInboundAction || allowRequestDockEntryAction) && (
              <button
                onClick={() => handlesClickCheckin.handleClickVehicleAction(record)}
                data-testid="vehicleActionRegister"
                hidden={unauthorizedRolesInLobbyTableActions(userData.role)}
              >
                <Tooltip placement="top" title={CALL_DRIVER}>
                  <UserOutlined className="vehicleActionRegister" data-testid="vehicleActionIcon" />
                </Tooltip>
              </button>
            )}
            <button onClick={() => handlesClickCheckin.handleClickCheckin(record)} data-testid="inbound-checkin-register" hidden={!isConcierge}>
              <Tooltip placement="top" title={CHECK_IN}>
                <In className="inboundCheckinRegister" data-testid="inbound-checkin-icon" />
              </Tooltip>
            </button>
          </S.ActionContainerCheckin>
        ),
    },
  ];

  return collums;
};

export default ColumnsTableCheckin;
